const changeGridLayout=()=>{
    document.body.classList.toggle('grid-3');
}
addEventListener("DOMContentLoaded", (event) => {
    let timeoutID;

    let button = document.createElement('button');
    button.id = "toggle-grid-layout";
    button.type = "button";
    button.title = "Change Grid Columns";
    button.onclick = function () {
        changeGridLayout()
    };
    timeoutID = setInterval(() => {
        const el = document.querySelector(".gf-filter-selection");
        if (el) {
            el.appendChild(button);
            clearInterval(timeoutID);
        }
    }, 100);

});